import {
  Box,
  Modal,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  CircularProgress,
  IconButton,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { useEffect, useState } from "react";
import xmlService from "../../../../services/xmlService";

interface ExcelLog {
  description: string;
  createDate: string;
  productBarcode: string;
}

const XmlRunTimeModal = ({ open, handleCloseModal, runTimeId }) => {
  const [logs, setLogs] = useState<ExcelLog[]>([]);
  const [loading, setLoading] = useState(false);
  const getExcelLogs = async (runTimeId: number) => {
    try {
      setLoading(true);
      const response = await xmlService.fetchRunTimesLogDetail(runTimeId);
      const logsData = response?.data?.data;
      console.log("logsData", logsData);
      setLogs(Array.isArray(logsData) ? logsData : []);
    } catch (error) {
      console.error("XML log fetch error:", error);
      setLogs([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (open && runTimeId) {
      getExcelLogs(runTimeId);
    }
  }, [open, runTimeId]);

  return (
    <Modal
      open={open}
      onClose={handleCloseModal}
      aria-labelledby="excel-runtime-modal"
      aria-describedby="excel-runtime-logs"
    >
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: "80%",
          maxWidth: 800,
          bgcolor: "background.paper",
          boxShadow: 24,
          borderRadius: 2,
          p: 4,
          maxHeight: "90vh",
          overflow: "auto",
        }}
      >
        {" "}
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            mb: 2,
          }}
        >
          <Typography id="excel-runtime-modal" variant="h6" component="h2">
            XML Hata Durumu
          </Typography>
          <IconButton
            aria-label="close"
            onClick={handleCloseModal}
            sx={{
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <CloseIcon />
          </IconButton>
        </Box>
        {loading ? (
          <Box sx={{ display: "flex", justifyContent: "center", p: 3 }}>
            <CircularProgress />
          </Box>
        ) : (
          <TableContainer component={Paper}>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell>Mesaj</TableCell>
                  <TableCell>Tarih</TableCell>
                  <TableCell>Ürün Barkodu</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {logs?.map((log, index) => (
                  <TableRow key={index}>
                    <TableCell>{log.description}</TableCell>
                    <TableCell>
                      {new Date(log.createDate).toLocaleString("tr-TR")}
                    </TableCell>
                    <TableCell>{log.productBarcode}</TableCell>
                  </TableRow>
                ))}
                {logs?.length === 0 && (
                  <TableRow>
                    <TableCell colSpan={2} align="center">
                      Kayıt bulunamadı
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </TableContainer>
        )}
      </Box>
    </Modal>
  );
};

export default XmlRunTimeModal;
